"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var stage = process.env.REACT_APP_STAGE;
/**
 * Default values for SndApiConfig initialization
 *
 * @category Config
 */

var defaultconfig = {
  local: {
    auth_host: 'http://localhost:4001/dev',
    campaign_host: 'http://localhost:6001/dev',
    billing_host: 'http://localhost:5001/dev',
    files_host: 'http://localhost:7001/dev',
    tester_host: 'http://localhost:8001/dev',
    analysis_host: 'http://localhost:8501/dev',
    panel_host: 'http://localhost:9001/dev',
    campaignId: 'default-campaign',
    scope: 'user'
  },
  localprod: {
    auth_host: 'http://localhost:4001/prod',
    campaign_host: 'http://localhost:6001/prod',
    billing_host: 'http://localhost:5001/prod',
    files_host: 'http://localhost:7001/prod',
    tester_host: 'http://localhost:8001/prod',
    analysis_host: 'http://localhost:8501/prod',
    panel_host: 'http://localhost:9001/prod',
    campaignId: 'default-campaign',
    scope: 'user'
  },
  test: {
    auth_host: 'https://c8bmhm2gi4.execute-api.eu-central-1.amazonaws.com/test',
    campaign_host: 'https://4z9otthvgi.execute-api.eu-central-1.amazonaws.com/test',
    billing_host: 'https://ukgarwagt2.execute-api.eu-central-1.amazonaws.com/test',
    files_host: 'https://vdm6qsvta6.execute-api.eu-central-1.amazonaws.com/test',
    tester_host: 'https://ruvlgjn61a.execute-api.eu-central-1.amazonaws.com/test',
    analysis_host: 'https://1i4cq0viq0.execute-api.eu-central-1.amazonaws.com/test',
    scope: 'user'
  },
  dev: {
    auth_host: 'https://4wgxeulct9.execute-api.eu-central-1.amazonaws.com/dev',
    campaign_host: 'https://1xhupja802.execute-api.eu-central-1.amazonaws.com/dev',
    billing_host: 'https://nb9lme7oye.execute-api.eu-central-1.amazonaws.com/dev',
    files_host: 'https://v9p7qievvc.execute-api.eu-central-1.amazonaws.com/dev',
    tester_host: 'https://ztd499va50.execute-api.eu-central-1.amazonaws.com/dev',
    analysis_host: 'https://vustxxj0pc.execute-api.eu-central-1.amazonaws.com/dev',
    panel_host: 'https://jctq4n0bm4.execute-api.eu-central-1.amazonaws.com/dev',
    scope: 'user'
  },
  beta: {
    auth_host: 'https://zscw0epbk2.execute-api.eu-central-1.amazonaws.com/beta',
    campaign_host: 'https://lt9tchzrs4.execute-api.eu-central-1.amazonaws.com/beta',
    billing_host: 'https://5rf1zela7c.execute-api.eu-central-1.amazonaws.com/beta',
    files_host: 'https://h1u84bvm76.execute-api.eu-central-1.amazonaws.com/beta',
    tester_host: 'https://kh06dfbaf5.execute-api.eu-central-1.amazonaws.com/beta',
    analysis_host: 'https://95usjk5n9e.execute-api.eu-central-1.amazonaws.com/beta',
    scope: 'user'
  },
  prod: {
    auth_host: 'https://8kf72e54kl.execute-api.eu-central-1.amazonaws.com/prod',
    campaign_host: 'https://n00orljmkh.execute-api.eu-central-1.amazonaws.com/prod',
    billing_host: 'https://l6km2gs839.execute-api.eu-central-1.amazonaws.com/prod',
    files_host: 'https://bb9i1p2dz1.execute-api.eu-central-1.amazonaws.com/prod',
    tester_host: 'https://yaofzixzy2.execute-api.eu-central-1.amazonaws.com/prod',
    analysis_host: 'https://imld93fcg0.execute-api.eu-central-1.amazonaws.com/prod',
    panel_host: 'https://iokpojegld.execute-api.eu-central-1.amazonaws.com/prod',
    scope: 'user'
  }
};
var config = defaultconfig[stage] || defaultconfig.dev;
exports.default = config;